import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Prescriber } from "../../../api";

@Component({
    selector: 'my-prescriber-page',
    templateUrl: 'prescriber-page.component.html',
    styleUrls: ['../active-controlled-medications-modal.component.scss']
})
export class PrescriberPage {
    private _prescribers: Prescriber[] = [];
    

    @Input() set prescribers(prescribers: Prescriber[]) {
        this._prescribers = prescribers;
        this.filteredPrescribers = prescribers;
        this.selectPrescriber();
    }
    @Output() prescribersChange = new EventEmitter<Prescriber>();

    areAllPrescribersSelected: boolean = false;
    hasSelectedPrescribers: boolean = false;
    selectedPrescriberCount: number = 0;
    searchText: string;

    filteredPrescribers: Prescriber[] = [];

    constructor() {

    }

    searchPrescribers(value: string){
        if(value !== undefined && value !== null) {
            let lowerSearch = value.toLowerCase();

            this.filteredPrescribers = this._prescribers.filter(prescriber => {
                let lowerCaseName = prescriber.FullName.toLowerCase();
                return lowerCaseName.indexOf(lowerSearch) >= 0;
            });
        }
    }

    selectPrescriber(){
        setTimeout(()=>{
            this.selectedPrescriberCount = this._prescribers.filter(x => x.IsSelected).length;

            if(this.areAllPrescribersSelected && this.selectedPrescriberCount === this._prescribers.length - 1){
                this._prescribers.forEach(f => f.IsSelected = !f.IsSelected);
                this.areAllPrescribersSelected = false;
                this.selectedPrescriberCount = 1;
            }else{
                this.hasSelectedPrescribers =  this.selectedPrescriberCount > 0;
                this.areAllPrescribersSelected = this._prescribers.length === this.selectedPrescriberCount;
            }
        });
    }

    selectAllPrescribers(){
        this._prescribers.forEach(ns => ns.IsSelected=true);
        this.selectPrescriber();
    }
}